import gql from "graphql-tag";

export const MY_NEWS_SET_ITEM_READ = gql`
  mutation setMyNewsItemRead($_id: String!) {
    setMyNewsItemRead(_id: $_id)
  }
`;
